import ProductSpecialsCarousel from 'components/product-specials-carousel/product-specials-carousel';

export default ProductSpecialsCarousel;
